"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(require("./InputAdornment"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/InputAdornment/index.js
// module id = 176
// module chunks = 0